// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-container {
  background: #f5f5f5;
  justify-self: center;
  margin-top: 35px;
  margin-bottom: 69px;
  height: 98vh;
}

.notification-scrollable-container {
  max-height: 66vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}
.notification-scrollable-container::-webkit-scrollbar {
  display: flex;
  width: 7px !important;
}

.notification-scrollable-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.notification-scrollable-container::-webkit-scrollbar-thumb {
  min-height: 5rem;
  background: var(--Colors-Text-200, #8e9190) !important;
  border-radius: 5px;
}

.notification-scrollable-container::-webkit-scrollbar-thumb:hover {
  background: #5b5e5d;
}

.notification-main-header {
  display: flex;
  justify-content: space-between;
  margin: 22px 30px 26px 30px;
}
.notification-card {
  width: 50vw;
  overflow-y: auto;
}
.id-size {
  font-size: 13px;
  margin-top: 0.4rem;
}
.notification-label {
  color: #000;
  font-size: 1.75rem;
  font-weight: 600;
}
.notifications-container .view-details {
  font-family: Roboto;
  border-radius: 5px;
  background: #f0f0f0 !important;
  display: flex;
  padding: 10px 14px;
  justify-content: center;
  align-items: center;
  color: #0a0f0d !important;
  gap: 8px;
  border: none;
  margin-top: 6px;
}
.notifications-container .view-details-date {
  display: flex;
  justify-content: space-between;
  width: 115%;
}
.notify-details {
  padding: 0 1.875rem 1.5rem 1.875rem;
}
.mark-read-btn {
  background: var(--Colors-Primary-500, #d2042d) !important;
  width: 95;
  height: 39;
  gap: 8px;
  padding-top: 12px;
  padding-right: 8px;
  padding-bottom: 12px;
  padding-left: 8px;
  left: 30px;
  border-radius: 5px;
  color: #fff !important;
  border-color: #d2042d !important;
}
.notify-checkbox {
  margin-right: 2rem;
  margin-top: 10px;
}
.notify-checkbox .ant-checkbox-inner {
  width: 24px;
  height: 24px;
}
.notify-desc {
  font-family: Roboto;
  color: #0a0f0d;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
}
.new-notification-mark {
  margin-left: 0.5rem;
}
span.ant-badge-status-dot {
  width: 10px !important;
  height: 10px !important;
  box-shadow: 0 0 8px 3px rgba(210, 4, 45, 0.2);
}

.notify-message {
  font-family: Roboto;
  color: #5b5e5d;
  font-size: 1rem;
  font-weight: 400;
  line-height: 24px;
}
.notify-divider {
  color: #f0f0f0;
  width: 100%;
  margin: 0;
}
.id-size:hover .copy-icon {
  opacity: 1;
}
.empty-notifications-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3rem;
}
.empty-notifications-card.ant-card .ant-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto !important;
  width: 510px;
}

@media (min-width: 0px) and (max-width: 768px) {
  .empty-notifications-card.ant-card .ant-card-body {
    width: 92vw;
  }
  .notification-small-screen-container {
    width: 50% !important;
    display: flex !important;
    justify-content: center !important;
  }
}
@media (max-width: 1025px) {
  .notification-card {
    width: 70vw;
  }
}

@media (max-width: 767px) {
  .notifications-container {
    margin-top: 0;
  }
  .notification-main-header {
    margin: 0;
  }
  .notification-card {
    width: 100vw;
    background: #f5f5f5;
  }
  .notification-scrollable-container {
    margin-top: 1rem;
  }
  .notification-scrollable-container::-webkit-scrollbar {
    display: none;
  }
  .notifications-container .view-details {
    background: #dbdbdb !important;
  }
  .notifications-container {
    height: 80vh !important;
  }
  .notification-scrollable-container {
    max-height: 77vh;
  }
}
@media (min-width: 769px) {
  .sub-text-size {
    font-size: 18px !important;
  }
}
@media (min-width: 1024px) {
  .notification-scrollable-container {
    max-height: 64vh !important;
  }
  .notifications-container {
    height: 80vh !important;
  }
}
@media (min-width: 426px) and (max-width: 767px) {
  .notifications-container {
    height: 80vh !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/notifications/Notifications.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yDAAyD;EACzD,SAAS;EACT,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;EACX,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,kCAAkC;EACpC;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".notifications-container {\n  background: #f5f5f5;\n  justify-self: center;\n  margin-top: 35px;\n  margin-bottom: 69px;\n  height: 98vh;\n}\n\n.notification-scrollable-container {\n  max-height: 66vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 8px;\n}\n.notification-scrollable-container::-webkit-scrollbar {\n  display: flex;\n  width: 7px !important;\n}\n\n.notification-scrollable-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.notification-scrollable-container::-webkit-scrollbar-thumb {\n  min-height: 5rem;\n  background: var(--Colors-Text-200, #8e9190) !important;\n  border-radius: 5px;\n}\n\n.notification-scrollable-container::-webkit-scrollbar-thumb:hover {\n  background: #5b5e5d;\n}\n\n.notification-main-header {\n  display: flex;\n  justify-content: space-between;\n  margin: 22px 30px 26px 30px;\n}\n.notification-card {\n  width: 50vw;\n  overflow-y: auto;\n}\n.id-size {\n  font-size: 13px;\n  margin-top: 0.4rem;\n}\n.notification-label {\n  color: #000;\n  font-size: 1.75rem;\n  font-weight: 600;\n}\n.notifications-container .view-details {\n  font-family: Roboto;\n  border-radius: 5px;\n  background: #f0f0f0 !important;\n  display: flex;\n  padding: 10px 14px;\n  justify-content: center;\n  align-items: center;\n  color: #0a0f0d !important;\n  gap: 8px;\n  border: none;\n  margin-top: 6px;\n}\n.notifications-container .view-details-date {\n  display: flex;\n  justify-content: space-between;\n  width: 115%;\n}\n.notify-details {\n  padding: 0 1.875rem 1.5rem 1.875rem;\n}\n.mark-read-btn {\n  background: var(--Colors-Primary-500, #d2042d) !important;\n  width: 95;\n  height: 39;\n  gap: 8px;\n  padding-top: 12px;\n  padding-right: 8px;\n  padding-bottom: 12px;\n  padding-left: 8px;\n  left: 30px;\n  border-radius: 5px;\n  color: #fff !important;\n  border-color: #d2042d !important;\n}\n.notify-checkbox {\n  margin-right: 2rem;\n  margin-top: 10px;\n}\n.notify-checkbox .ant-checkbox-inner {\n  width: 24px;\n  height: 24px;\n}\n.notify-desc {\n  font-family: Roboto;\n  color: #0a0f0d;\n  font-size: 1rem;\n  font-weight: 500;\n  display: flex;\n  justify-content: space-between;\n}\n.new-notification-mark {\n  margin-left: 0.5rem;\n}\nspan.ant-badge-status-dot {\n  width: 10px !important;\n  height: 10px !important;\n  box-shadow: 0 0 8px 3px rgba(210, 4, 45, 0.2);\n}\n\n.notify-message {\n  font-family: Roboto;\n  color: #5b5e5d;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 24px;\n}\n.notify-divider {\n  color: #f0f0f0;\n  width: 100%;\n  margin: 0;\n}\n.id-size:hover .copy-icon {\n  opacity: 1;\n}\n.empty-notifications-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 3rem;\n}\n.empty-notifications-card.ant-card .ant-card-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: auto !important;\n  width: 510px;\n}\n\n@media (min-width: 0px) and (max-width: 768px) {\n  .empty-notifications-card.ant-card .ant-card-body {\n    width: 92vw;\n  }\n  .notification-small-screen-container {\n    width: 50% !important;\n    display: flex !important;\n    justify-content: center !important;\n  }\n}\n@media (max-width: 1025px) {\n  .notification-card {\n    width: 70vw;\n  }\n}\n\n@media (max-width: 767px) {\n  .notifications-container {\n    margin-top: 0;\n  }\n  .notification-main-header {\n    margin: 0;\n  }\n  .notification-card {\n    width: 100vw;\n    background: #f5f5f5;\n  }\n  .notification-scrollable-container {\n    margin-top: 1rem;\n  }\n  .notification-scrollable-container::-webkit-scrollbar {\n    display: none;\n  }\n  .notifications-container .view-details {\n    background: #dbdbdb !important;\n  }\n  .notifications-container {\n    height: 80vh !important;\n  }\n  .notification-scrollable-container {\n    max-height: 77vh;\n  }\n}\n@media (min-width: 769px) {\n  .sub-text-size {\n    font-size: 18px !important;\n  }\n}\n@media (min-width: 1024px) {\n  .notification-scrollable-container {\n    max-height: 64vh !important;\n  }\n  .notifications-container {\n    height: 80vh !important;\n  }\n}\n@media (min-width: 426px) and (max-width: 767px) {\n  .notifications-container {\n    height: 80vh !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
